import React from 'react';
import { useState } from 'react';
import { PlanContext } from '../../context/PlanContext';
import { IoEyeOffOutline , IoEyeOutline } from "react-icons/io5";
import PlanInfoModal from '../../components/dialogs/planInfoModal';

export function PlanInfo({ plan, newMapPlans, handleClick }) {
    const [openPlanInfo, setOpenPlanInfo] = useState(false);

    return (
        <div
            key={plan.id}
            className={`group flex flex-col w-full items-center justify-normal mb-2 pr-2 rounded-md border-1`}
        >
            <div
                className={
                    'flex flex-row text-gray-600 flex-1 align-start py-2 w-full'
                }
            >
                {newMapPlans.includes(plan.id) ? (
                    <IoEyeOutline
                        onClick={() => handleClick(true, plan.id)}
                        className='hover:text-gray-600 cursor-pointer h-5 w-5 mr-2 rounded ring-white text-gray-900'
                    />
                ) : (
                    <IoEyeOffOutline
                        onClick={() => handleClick(false, plan.id)}
                        className='hover:text-indigo-600 cursor-pointer h-5 w-5 mr-2 rounded ring-white text-gray-600/50'
                    />
                )}

                <div
                    className={`truncate flex-1 flex flex-col${
                        plan?.selected ? 'text-gray-900' : ''
                    }`}
                >
                    <div
                        className= {(newMapPlans.includes(plan.id)) ? ' text-sm truncate text-gray-900  hover:text-indigo-600 hover:cursor-pointer' : 'truncate text-gray-600/50 text-sm hover:text-indigo-600 hover:cursor-pointer'}
                        onClick={() => {
                            setOpenPlanInfo(true);
                        }}
                    >
                        {plan.name}
                    </div>
                </div>
            </div>
            <PlanContext.Provider
                value={{ openPlanInfo, setOpenPlanInfo, plan }}
            >
                <PlanInfoModal />
            </PlanContext.Provider>
        </div>
    );
}
